/*
 * Merchant: the "File The Shipping Order" button in the Crate drawer opened
 * a local pre-flight modal ("Where Is This Going?", asking for a name under
 * the label "Consignee name") that quoted a flat, made-up "Freight" figure
 * (this.subtotalNum()>250 ? 'No Charge' : '$24' — see renderVals in
 * assets/sat-app.js) before the real Shopify checkout ever calculated real
 * shipping. That flat figure has no relationship to what a given address
 * actually costs to ship to, so it was quoting customers a freight number
 * that could be flatly wrong for their real address — reported as scaring
 * customers off before they ever reached the real, accurate total.
 *
 * Rather than try to make the local modal's estimate honest (there's no way
 * to compute real freight client-side before Shopify's own rate shopping
 * runs), this skips the modal entirely: the Crate's checkout button now
 * goes straight to Shopify's real checkout, exactly like placeOrder()
 * already did after that modal's form was filled in and submitted. Wraps
 * SATComponent.prototype.renderVals to replace the openCheckout handler it
 * builds each render; checkoutOpen itself, and the modal markup in
 * snippets/sat-overlays.liquid, are simply never triggered any more.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var proto = window.SATComponent.prototype;

  var origRenderVals = proto.renderVals;
  proto.renderVals = function () {
    var out = origRenderVals.call(this);
    var self = this;
    out.openCheckout = function () {
      if (typeof self.playReadyChime === 'function') { self.playReadyChime(); }
      var url = (window.SAT_DATA && window.SAT_DATA.routes && window.SAT_DATA.routes.checkout) || '/checkout';
      window.location.href = url;
    };
    return out;
  };
})();
